class SealVideoPopup {
  constructor() {
    this.popup = document.querySelector('.js-seal-video-popup');
    if (!this.popup) return;

    document.body.appendChild(this.popup);

    this.video = this.popup.querySelector('.js-seal-video');
    this.trigger = document.querySelector('.js-seal-video-trigger');

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);

    this.trigger?.addEventListener('click', this.open);
    this.popup.addEventListener('click', this.handleCloseClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  open() {
    this.popup.classList.add('is-active');
    this.popup.removeAttribute('inert');
    document.body.classList.add('overflow-hidden');
    this.video?.play();
  }

  close() {
    if (!this.popup.classList.contains('is-active')) return;

    this.video?.pause();
    if (this.video) this.video.currentTime = 0;

    this.popup.classList.remove('is-active');
    this.popup.setAttribute('inert', '');
    document.body.classList.remove('overflow-hidden');

    this.trigger?.focus({ preventScroll: true });
  }

  handleCloseClick(event) {
    if (event.target.closest('.js-seal-video-close')) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

new SealVideoPopup();
